import { render, staticRenderFns } from "./ToStart.vue?vue&type=template&id=57fd070c&scoped=true"
import script from "./ToStart.vue?vue&type=script&lang=js"
export * from "./ToStart.vue?vue&type=script&lang=js"
import style0 from "./ToStart.vue?vue&type=style&index=0&id=57fd070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd070c",
  null
  
)

export default component.exports